import DocumentCard from "../../components/DocumentCard";

const countries = [
  {
    name: "Grecia",
    image: "/proiecte/Erasmus+/steag/grecia.png",
    linkType: "page",
    link: "/proiecte/Erasmus+/Grecia",
  },
  {
    name: "Letonia",
    image: "/proiecte/Erasmus+/steag/letonia.png",
    linkType: "page",
    link: "/proiecte/Erasmus+/Letonia",
  },
  {
    name: "Turcia",
    image: "/proiecte/Erasmus+/steag/turcia.png",
    linkType: "page",
    link: "/proiecte/Erasmus+/Turcia",
  },
  {
    name: "România",
    image: "/proiecte/Erasmus+/steag/romania.png",
    linkType: "page",
    link: "/proiecte/Erasmus+/Romania",
  },
  {
    name: "Italia",
    image: "/proiecte/Erasmus+/steag/italia.png",
    linkType: "page",
    link: "/proiecte/Erasmus+/Italia",
  },
];

export default function Erasmus() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="w-full flex justify-center mb-8">
          <img
            src={"/proiecte/Erasmus+/banner_2_001.png"}
            alt="Banner Erasmus+"
            style={{ objectPosition: "center" }}
          />
        </div>
        <h1 className="text-2xl font-bold mb-4 text-center">
          OUR PAST OUR FUTURE
        </h1>
        <p className="mt-12 mb-2">
          <span className="font-semibold">Numărul proiectului:</span>
          2019-1-IT02-KA229-062420_5
        </p>
        <p className="mb-2">
          <span className="font-semibold">Tipul proiectului:</span> Proiect de
          parteneriat strategic în domeniul şcolar, din cadrul programului
          ERASMUS+
        </p>
        <p className="mb-2 font-semibold">Parteneri:</p>
        <ul className="list-disc ml-6 mb-4">
          <li>Geniko Lykeio Katerinis, Katerini, Greece</li>
          <li>Razekne State Gymnasium No1, Rezekne, Latvia</li>
          <li>I.I.S. Fermi Filangeri from Formia, Italy</li>
          <li>Dr. Kemal Naci Eksi Anadolu Lisesi, Istanbul, Turkey</li>
        </ul>
        <p className="mb-2 font-semibold">Obiectivele proiectului:</p>
        <ul className="list-disc ml-6 mb-4">
          <li>
            Stimularea creativității, prin soluționarea problemelor legate de
            repunerea în circuitul turistic a patrimoniului cultural
            nevalorificat.
          </li>
          <li>
            Dezvoltarea competențelor antreprenoriale în domeniul turistic și
            cultural, prin promovarea tradițiilor și obiceiurilor.
          </li>
          <li>Cultivarea sentimentului identității europene.</li>
          <li>
            Consolidarea abilitătilor de comunicare într-o altă limbă de
            circulație internațională.
          </li>
          <li>Îmbunătățirea competențelor informatice.</li>
          <li>Construirea unor alianțe trainice prin diversitate culturală.</li>
          <li>Dezvoltarea gândirii critice și creative.</li>
        </ul>
        <p className="mb-2 font-semibold">Descrierea proiectului:</p>
        <p className="mb-4">
          Proiectul de parteneriat strategic în domeniul școlar, din cadrul
          programului Erasmus +, cu titlul ”Our past our future” se desfășoară
          în perioada 01.09.2019-31.08.2022.
        </p>
        <p className="mb-2">
          <span className="font-semibold">Grupul țintă:</span> 22 de elevi între
          15-18 ani.
        </p>
        <p className="mb-2">
          În cadrul proiectului se vor desfășura întâlniri in:
        </p>
        <ul className="list-disc ml-6 mb-4">
          <li>Grecia, orașul Katerini - decembrie 2019</li>
          <li>Letonia, orașul Rezekne – octombrie 2021</li>
          <li>Turcia, orașul Istanbul – martie 2022</li>
          <li>România, orașul Ulmeni – mai 2022</li>
          <li>Italia, orașul Formia - mai 2022</li>
        </ul>
        <p className="mb-2">
          Limba oficială a proiectului va fi limba engleză.
        </p>
        <p className="mb-2">Elevii vor fi găzduiți în familii.</p>
        <p className="mb-4">
          În cadrul acestor întâlniri organizate de către parteneri, elevii
          gazdă împărtășesc moștenirile lor culturale legate de monumentele
          locale și împreună vor descoperi modul în care, valorificarea acestui
          patrimoniu poate contribui la crearea de locuri de muncă, la
          dezvoltarea economică a zonei și, implicit, la bunăstarea lor socială.
        </p>
        <p className="mb-4">
          Prin coeziune, elevii participanți vor învăța cum să consolideze
          economia orașului gazdă, prin activități de antreprenoriat în domeniul
          turistic, cultural, promovând în același timp, tradițiile, obiceiurile
          locale ale zonei.
        </p>
        <p className="mb-4">
          Toate activitățile din cadrul proiectului vor fi încărcate pe
          platforma eTwinning, unde elevii vor avea posibilitatea de a
          socializa.
        </p>
        <p className="mb-2 font-semibold">Diseminarea și valorizare:</p>
        <ul className="list-disc ml-6 mb-4">
          <li>Crearea logoul Proiectului;</li>
          <li>
            Prezentări PPT despre orasele și școlile implicate în proiect;
          </li>
          <li>Afișe după fiecare întâlnire;</li>
          <li>Broșura fiecărei ședințe;</li>
          <li>
            Prezentări cu tematica proiectului: modalitățile de dezvoltare a
            economiei orașului gazdă;
          </li>
          <li>CV europass;</li>
          <li>Poze, filmări de la fiecare ședință/ întâlnire;</li>
          <li>Colțul Proiectului;</li>
          <li>
            Promovarea activităților în mass-media, reviste, site-ul școlii,
            rețelele de socializare.
          </li>
        </ul>
        <div className="flex justify-center gap-4 flex-wrap lg:flex-nowrap">
          {countries.map((country, idx) => (
            <DocumentCard key={idx} {...country} />
          ))}
        </div>
      </main>
    </div>
  );
}
